import {
    GET_PARTY_REQUEST,
    GET_PARTY_SUCCESS,
    GET_PARTY_FAILURE,
    PARTY_LOGIN_REQUEST,
    PARTY_LOGIN_SUCCESS,
    PARTY_LOGIN_FAILURE,
    PARTY_LOGIN_DIRECTLY_REQUEST,
    PARTY_LOGIN_DIRECTLY_SUCCESS,
    PARTY_LOGIN_DIRECTLY_FAILURE,
    CHECK_JOINED_REQUEST,
    CHECK_JOINED_SUCCESS,
    CHECK_JOINED_FAILURE,
    GET_RECORDS_REQUEST,
    GET_RECORDS_SUCCESS,
    GET_RECORDS_FAILURE,
    UPLOAD_RECORD_REQUEST,
    UPLOAD_RECORD_SUCCESS,
    UPLOAD_RECORD_FAILURE,
    GET_LEADERBOARD_REQUEST,
    GET_LEADERBOARD_SUCCESS,
    GET_LEADERBOARD_FAILURE,
    GET_PARTY_RECORD_REQUEST,
    GET_PARTY_RECORD_SUCCESS,
    GET_PARTY_RECORD_FAILURE,
    SYNC_PROFILE_REQUEST,
    SYNC_PROFILE_SUCCESS,
    SYNC_PROFILE_FAILURE,
} from '../constant/actionTypes'

export const getParty = payload => ({
    type: GET_PARTY_REQUEST,
    payload
})

export const getPartySuccess = payload => ({
    type: GET_PARTY_SUCCESS,
    payload
})

export const getPartyFailure = payload => ({
    type: GET_PARTY_FAILURE,
    payload
})

export const partyLogin = payload => ({
    type: PARTY_LOGIN_REQUEST,
    payload
})

export const partyLoginSuccess = payload => ({
    type: PARTY_LOGIN_SUCCESS,
    payload
})

export const partyLoginFailure = payload => ({
    type: PARTY_LOGIN_FAILURE,
    payload
})

export const partyLoginDirectly = payload => ({
    type: PARTY_LOGIN_DIRECTLY_REQUEST,
    payload
})

export const partyLoginDirectlySuccess = payload => ({
    type: PARTY_LOGIN_DIRECTLY_SUCCESS,
    payload
})

export const partyLoginDirectlyFailure = payload => ({
    type: PARTY_LOGIN_DIRECTLY_FAILURE,
    payload
})

export const checkJoined = payload => ({
    type: CHECK_JOINED_REQUEST,
    payload
})

export const checkJoinedSuccess = payload => ({
    type: CHECK_JOINED_SUCCESS,
    payload
})

export const checkJoinedFailure = payload => ({
    type: CHECK_JOINED_FAILURE,
    payload
})

export const getRecords = payload => ({
    type: GET_RECORDS_REQUEST,
    payload
})

export const getRecordsSuccess = payload => ({
    type: GET_RECORDS_SUCCESS,
    payload
})

export const getRecordsFailure = payload => ({
    type: GET_RECORDS_FAILURE,
    payload
})

export const uploadRecord = payload => ({
    type: UPLOAD_RECORD_REQUEST,
    payload
})

export const uploadRecordSuccess = payload => ({
    type: UPLOAD_RECORD_SUCCESS,
    payload
})

export const uploadRecordFailure = payload => ({
    type: UPLOAD_RECORD_FAILURE,
    payload
})

export const getLeaderboard = payload => ({
    type: GET_LEADERBOARD_REQUEST,
    payload
})

export const getLeaderboardSuccess = payload => ({
    type: GET_LEADERBOARD_SUCCESS,
    payload
})

export const getLeaderboardFailure = payload => ({
    type: GET_LEADERBOARD_FAILURE,
    payload
})

export const getPartyRecord = payload => ({
    type: GET_PARTY_RECORD_REQUEST,
    payload
})

export const getPartyRecordSuccess = payload => ({
    type: GET_PARTY_RECORD_SUCCESS,
    payload
})

export const getPartyRecordFailure = payload => ({
    type: GET_PARTY_RECORD_FAILURE,
    payload
})

export const syncProfile = payload => ({
    type: SYNC_PROFILE_REQUEST,
    payload
})

export const syncProfileSuccess = payload => ({
    type: SYNC_PROFILE_SUCCESS,
    payload
})

export const syncProfileFailure = payload => ({
    type: SYNC_PROFILE_FAILURE,
    payload
})